import React, {useContext} from 'react'
import {general as textsGeneral} from '../../../translate/Translate.jsx'
import {IconButton} from '@mui/material'
import {ArrowForwardRounded as ArrowForwardRoundedIcon} from '@mui/icons-material'
import {ShoppingCartContext} from '../../../context/ShoppingCartContext.jsx'

import './cartStepsButton.scss'

const CartStepsButton = ({total, clickNext}) => {
    const {isAddItem} = useContext(ShoppingCartContext)
    return <div className={'cart-steps-button'}>
        <div className={'container-cart-steps-button'}>
            <div className={'left'}>
                <label className={'label-price'} id={isAddItem ? 'add-item-cart' : 'remove-item-cart'}>
                    {total.toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    })}
                </label>
            </div>
            <div className={'button'} onClick={() => clickNext()}>
                <label className={'label-add'}>
                    {textsGeneral.continue}
                </label>
                <IconButton>
                    <ArrowForwardRoundedIcon className={'icon'}/>
                </IconButton>
            </div>
        </div>
    </div>
}

export default CartStepsButton
